import type { GetMembershipAccountResponse } from '@fourthwall/services/dist/MembershipsApiClient'
import { MembershipsApiClient } from '@fourthwall/services/dist/MembershipsApiClient'
import type { UseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'

export const useMembershipAccountQuery = (
  options?: UseQueryOptions<GetMembershipAccountResponse>,
) => {
  const membershipAccountQuery = useQuery<GetMembershipAccountResponse>({
    queryKey: ['membershipAccount'],
    queryFn: async () => {
      const { data } = await MembershipsApiClient.getAccount()

      return data
    },
    ...(options || {}),
    retry: false,
    onError: () => {
      // NOTE: we have to ignore default error behavior since 404 simply means that memberships are not configured,
      // and we don't need error message then
    },
  })

  return {
    membershipAccountQuery,
  }
}
